import React from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const Header = ({ course, onClose }) => (
  <div className='relative bg-gradient-to-r from-primary to-secondary px-6 py-5 text-white'>
    <IconButton
      aria-label='Cerrar'
      onClick={onClose}
      size='small'
      sx={{ position: 'absolute', top: 8, right: 8, color: '#ffffff' }}>
      <CloseIcon fontSize='small' />
    </IconButton>
    <p className='text-xs font-semibold uppercase tracking-wider text-white/80'>
      Programa del curso
    </p>
    <h2 id='course-program-title' className='mt-1 text-xl font-bold leading-tight'>
      {course?.name}
    </h2>
    <p id='course-program-description' className='mt-1 text-sm text-white/90'>
      Año: {course?.year} · Semestre: {course?.semester}
    </p>
  </div>
);

export default Header;
